<template>
  <div>
    <ToolbarAuth />
    <Navigation />

    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text"> TEAM </v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead></thead>
            <tbody>
              <tr>
                <td>id</td>
                <td>{{ teamsingle.id }}</td>
              </tr>
              <tr>
                <td>Team</td>
                <td>{{ teamsingle.team_name }}</td>
              </tr>
              <tr>
                <td>{{ $t("team.company") }}</td>
                <td>{{ teamsingle.company_name }}</td>
              </tr>
              <tr>
                <td>{{ $t("team.adress") }}</td>
                <td>{{ teamsingle.adress }}</td>
              </tr>
              <tr>
                <td>{{ $t("team.zip") }}</td>
                <td>{{ teamsingle.zip_code }}</td>
              </tr>
              <tr>
                <td>e-mail info</td>
                <td>{{ teamsingle.email_info }}</td>
              </tr>
              <tr>
                <td>{{ $t("team.tel") }}</td>
                <td>{{ teamsingle.telephone }}</td>
              </tr>
              <tr>
                <td>Website</td>
                <td>{{ teamsingle.website }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeView()" large class="ma-5" color="accent">
            {{ $t("crud.close") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
export default {
  name: "userview",
  components: { ToolbarAuth, Navigation },
  data() {
    return {};
  },
  methods: {
    closeView() {
      this.$router.push({ name: "teamsIndex" });
    },
  },
  computed: {
    ...mapGetters("teamsingle", ["loading", "error", "teamsingle"]),
  },
  created() {
    let TeamId = this.$route.params.id;
    this.$store.dispatch("teamsingle/getTeam", TeamId);
  },
};
</script>

<style scoped></style>
